import { fetchWithAuth } from './utils';

export async function createGateway(values) {
    const response = await fetchWithAuth(`${process.env.REACT_APP_API_URL}/chirpstack/create-gateway`, {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json',
        },
        body: JSON.stringify(values),
    });

    if (!response.ok) {
        const errorText = await response.text();
        throw new Error(errorText);
    }

    return await response.json();
}